import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateZipcodeInternacionalActions } from "store/ducks/settings/zipcode-internacional";

export function* createZipcodeInternacionalRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(apiGeneral.post, `/zipcode-internacional`, postData);

    const { data } = responseBody;
    yield put(CreateZipcodeInternacionalActions.success(data));
    notify("success", "Zipcode cadastrado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateZipcodeInternacionalActions.failure(errorMessage));
  }
}
